import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";

import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const Container = styled(FlexColumn)<{ withBorder?: boolean }>`
    box-sizing: border-box;
    padding: 16px;
    width: 100%;
    min-width: 176px;
    height: 230px;
    gap: 16px;
    position: relative;
    flex-grow: 1;
    ${({ withBorder = true }) =>
        withBorder &&
        css`
            border-right: 1px solid ${carbon[50]};
        `};
`;

export const NoDataWrapper = styled(CenteredFlexRow)`
    flex: 1;
    height: 100%;
`;
